module.exports = __webpack_public_path__ + "mobileLogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobileLogo.png
// module id = 300
// module chunks = 0